import { v4 as uuid } from 'uuid';

import { IPatient, v2 } from '../../..';
import { getDefaults } from './helpers/getDefaults';

export const contactRecordAdapter = (patient: Partial<IPatient>): v2.ContactRecord[] => {
    const {
        addressLine1,
        addressLine2,
        addressLine3,
        town,
        county,
        postCode,
        contactNumber,
        latitude,
        longitude,
        additionalContactNumbers,
        geocodedAddress,
    } = patient;

    const phoneNumbers = [contactNumber, ...(additionalContactNumbers || [])].filter((str) => str);

    const defaults = getDefaults(patient);

    const contactRecords: v2.ContactRecord[] = [];

    if (addressLine1) {
        contactRecords.push({
            ...defaults,
            addressLine1,
            addressLine2,
            addressLine3,
            town,
            county,
            postCode,
            latitude,
            longitude,
            geocodedAddress,
            id: uuid(),
            contactType: v2.ContactType.ADDRESS,
        });
    }

    phoneNumbers.forEach((number) => {
        contactRecords.push({
            ...defaults,
            phoneNumber: number,
            id: uuid(),
            contactType: v2.ContactType.PHONE,
        });
    });

    return contactRecords;
};
